export default __webpack_public_path__ + "static/media/tick-white.b526ccb2.svg";